import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

/**
 * Wie ein Kunde in den Kundeninfos adressiert wird: lokale UUID, falls bekannt,
 * sonst die ID im führenden System — der Server löst beides auf.
 */
export interface CustomerInfoIdent {
  localCustomerId?: string;
  weclappCustomerId?: string;
  cwCompanyId?: number;
}

function identKey(ident: CustomerInfoIdent) {
  return ident.localCustomerId ?? ident.weclappCustomerId ?? ident.cwCompanyId;
}

function toApiIdent(ident: CustomerInfoIdent) {
  return {
    customerId: ident.localCustomerId,
    weclappCustomerId: ident.weclappCustomerId,
    cwCompanyId: ident.cwCompanyId,
  };
}

/**
 * Pflege-Daten: Besonderheiten, Vertrag, Ansprechpartner. Mehrere Karten und die
 * Reiter-Zähler lesen denselben Schlüssel — geladen wird trotzdem nur einmal.
 */
export function useCustomerCare(ident: CustomerInfoIdent, options: { enabled?: boolean } = {}) {
  const queryKey = ['customer-care', identKey(ident)] as const;
  const query = useQuery({
    queryKey,
    queryFn: () => api.getCustomerCare(toApiIdent(ident)),
    staleTime: 30_000,
    retry: false,
    enabled: options.enabled ?? true,
  });
  return { ...query, queryKey };
}

/** Verträge & Lizenzen — derselbe Schlüssel wie auf der Seite „Verträge & Lizenzen". */
export function useCustomerDeadlines(ident: CustomerInfoIdent, options: { enabled?: boolean } = {}) {
  const queryKey = ['customer-deadlines-tech', identKey(ident)] as const;
  const query = useQuery({
    queryKey,
    queryFn: () => api.getCustomerDeadlines(toApiIdent(ident)),
    staleTime: 30_000,
    retry: false,
    enabled: options.enabled ?? true,
  });
  return { ...query, queryKey };
}
